
import { FETCH_SIDE_EFFECTS } from '../constants/actionTypes';

const sideEffects = (sideEffects = [], action) => {
  switch (action.type) {
    case FETCH_SIDE_EFFECTS:
      return action.payload;
    default:
      return sideEffects;
  }
};

export default sideEffects;
